module.exports = __webpack_public_path__ + "turismo.jpg?11039a6dfad988c65faa3ef880e48233";